import React, { Component } from 'react'
import { Modal } from 'hljd'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import QRCode from 'qrcode.react'

@observer
export default class extends Component {
  render() {
    const {
      visible,
      QrCode,
      price,
      checkApi,
      close,
      payAlready,
      payType
    } = this.props.store

    return (
      <Modal footer={null} width={690} visible={visible} onCancel={close}>
        <div className={styles.modalbox}>
          <p className={styles.title}>{payType == 1 ? '微信' : '支付宝'}支付</p>
          <div className={styles.inner}>
            <p style={{ margin: '25px 0 10px 0' }}>扫一扫付款(元)</p>
            <p className={styles.money}>{price}</p>
            <QRCode value={QrCode} size={180} />
            {payType == 1 && (
              <div className={styles.tip}>
                使用<img src="//qnm.hunliji.com/o_1botirh763s132sbfi10v119d18.png" />
                <span>微信支付</span>
              </div>
            )}

            {payType == 2 && (
              <div className={styles.tip}>
                使用<img src="//qnm.hunliji.com/o_1boucjbkf48tqtg1gv2sfshoqb.png" />
                <span>支付宝支付</span>
              </div>
            )}
          </div>
          {!checkApi && (
            <div className={styles.btnClick}>
              <span className={styles.yes} onClick={payAlready}>
                已支付成功
              </span>
              <span className={styles.close} onClick={close}>
                关闭
              </span>
            </div>
          )}
        </div>
      </Modal>
    )
  }
}
